'use strict';

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// You must register a React component here before calling
// render_react_component in PHP
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

module.exports = {

  /**
  * common components used between HS and HF
  */

  Button: require('common/components/button'),
  ButtonTextSubmit: require('common/components/button-text-submit'),
  Input: require('common/components/input'),
  FillEmptySpace: require('common/components/fill-empty-space'),
  PeekABoo: require('common/components/peekaboo'),
  DropDownMenu: require('common/components/drop-down-menu'),
  MobileLinkSubmit: require('common/components/mobile-link-submit'),
  Notification: require('common/components/notifications/index'),
  CloseFancyBoxButton: require('common/components/close-fancy-box-button'),
  IntegrationActivationButton: require('common/components/integration-activation-button'),
  Banner: require('common/components/banner'),
  Tooltip: require('common/components/tooltip'),

  /**
   * HS
   */

  AppTopBar: require('./app/header'),
  AppLeftMenu: require('./app/sidebar'),
  AppFooter: require('./app/footer'),
  HSTeamPage: require('./app/content/team'),

  TwoOptionTabPane: require('./api/two-option-tab-pane'),
  StandardTabPane: require('./api/standard-tab-pane'),

  ApiMenu: require('./api-docs/api-menu'),
  CodeTabPane: require('./api-docs/code-tab-pane'),
  CodeTabPaneWithResponse: require('./api-docs/code-tab-pane-with-response'),
  ImageModalTrigger: require('./api-docs/image-modal-trigger'),
  SendExampleSignatureRequestForm: require('./api-docs/send-example-signature-request-form'),

  CreateAccount: require('./auth/create-account'),
  LogInVerificationForm: require('./auth/login-verification-form'),
  LogInModal: require('./auth/login-modal'),
  CreateAccountTrigger: require('./auth/create-account-trigger'),
  LogInTrigger: require('./auth/login-trigger'),
  GoogleLoginOrSignup: require('./auth/google-login-or-signup'),
  LogInForm: require('./auth/login-form'),
  VerifyEmail: require('./auth/verify-email'),
  LogInInPerson: require('./auth/login-in-person'),

  HomePageSignup: require('./home/signup'),
  HomePageManualSignup: require('./home/manual-signup'),
  TopBarMenu: require('./home/top-bar-menu'),
  TopBarMenuLink: require('./home/top-bar-menu/top-bar-menu-link'),
  LogInButton: require('./home/top-bar-menu/login-button'),
  SignUpButton: require('./home/top-bar-menu/signup-button'),
  CancelSubscriptionPage: require('./home/cancel-subscription/cancel-subscription-page'),
  BlackBarAnnouncements: require('./home/black-bar-announcements'),

  PricingArea: require('./pricing'),
  PaymentModal: require('./pricing/payment-modal'),
  EnterpriseAgreement: require('./pricing/enterprise-agreement'),
  TabbedArea: require('./tabbed-area'),
  MarketoForm: require('./marketo-form'),

  /**
   * HF
   */

  FaxLineConfigList: require('./app/content/team/team-fax-lines'),

  /**
   * Landing Pages
   */
  ESignatureFree: require('landing-pages/components/e-signature-free'),
  AutomatePaperwork: require('landing-pages/components/automate-paperwork'),
  AutomateWorkflow: require('landing-pages/components/automate-workflow'),
  OnlineDigitalSignatures: require('landing-pages/components/online-digital-signatures'),
  OnlineContract: require('landing-pages/components/online-contract'),
  FreeEsignatureTool: require('landing-pages/components/free-esignature-tool'),
  SignDocumentsElectronically: require('landing-pages/components/sign-documents-electronically'),
  HowCreateElectronicSignature: require('landing-pages/components/how-create-electronic-signature'),
  HowToSignOnline: require('landing-pages/components/how-to-sign-online'),
  OnlineSignatureApp: require('landing-pages/components/online-signature-app'),
  ElectronicSignature: require('landing-pages/components/electronic-signature'),
  DigitalSignature: require('landing-pages/components/digital-signature'),
  ESignaturesSEO: require('landing-pages/components/esignatures'),
  ESignSEO: require('landing-pages/components/esign'),
  PDFESignatureSEO: require('landing-pages/components/pdf-esignature'),
  Dropbox: require('landing-pages/components/dropbox'),
  Box: require('landing-pages/components/box'),
  Evernote: require('landing-pages/components/evernote'),
  OneDrive: require('landing-pages/components/onedrive'),
  EventbriteLandingPage: require('landing-pages/components/eventbrite-landing-page'),
  WhiteLabelingLandingPage: require('landing-pages/components/white-labeling'),
  DocusignSwitch: require('landing-pages/components/docusign-switch')
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/index.js
 ** module id = 604
 ** module chunks = 0
 **/